import { useLayoutEffect, useState } from 'react';
import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";

function QaAreaChart(props) {


  useLayoutEffect(() => {
    let root = am5.Root.new("chartdiv");


    // Set themes
    // https://www.amcharts.com/docs/v5/concepts/themes/
    root.setThemes([
    am5themes_Animated.new(root)
    ]);

    // Create chart
    // https://www.amcharts.com/docs/v5/charts/xy-chart/
    let chart = root.container.children.push(am5xy.XYChart.new(root, {
        panX: true,
        panY: true,
        wheelX: "panX",
        wheelY: "zoomX",
        pinchZoomX: true,
        paddingLeft:0,
        paddingRight:1
    }));

    // Add cursor
    // https://www.amcharts.com/docs/v5/charts/xy-chart/cursor/
    let cursor = chart.set("cursor", am5xy.XYCursor.new(root, {}));
    cursor.lineY.set("visible", false);

    // Create axes
    // https://www.amcharts.com/docs/v5/charts/xy-chart/axes/
    let xRenderer = am5xy.AxisRendererX.new(root, { 
        minGridDistance: 30, 
        minorGridEnabled: true
    });

    xRenderer.labels.template.setAll({
        rotation: -45,
        centerY: am5.p50,
        centerX: am5.p100,
        // paddingRight: 15,
        fontSize: 14,
      });

    xRenderer.grid.template.setAll({
    location: 1
    });

    let xAxis = chart.xAxes.push(am5xy.CategoryAxis.new(root, {
        maxDeviation: 0.3,
        categoryField: "name",
        renderer: xRenderer,
        tooltip: am5.Tooltip.new(root, {})
      }));

    let yRenderer = am5xy.AxisRendererY.new(root, {
    strokeOpacity: 0.1
    })
    
    let yAxis = chart.yAxes.push(am5xy.ValueAxis.new(root, {
    maxDeviation: 0.3,
    renderer: yRenderer
    }));

    // xAxis.get("renderer").grid.template.set("forceHidden", true);
    // yAxis.get("renderer").grid.template.set("forceHidden", true);
    xAxis.get("renderer").grid.template.setAll({
      strokeOpacity: 0.1 // Adjust opacity (0 = fully transparent, 1 = fully visible)
    });
    yAxis.get("renderer").grid.template.setAll({
      strokeOpacity: 0.1 // Adjust opacity (0 = fully transparent, 1 = fully visible)
    });

    yAxis.children.moveValue(am5.Label.new(root, { text: "Concentration (mg/L)", rotation: -90, y: am5.p50, centerX: am5.p50 }), 0);
    xAxis.children.push(am5.Label.new(root, { text: "Injections", x: am5.p50, centerX: am5.p50 }));


    // Create series
    // https://www.amcharts.com/docs/v5/charts/xy-chart/series/
    let series = chart.series.push(am5xy.ColumnSeries.new(root, {
        name: "Series 1",
        xAxis: xAxis,
        yAxis: yAxis,
        valueYField: "value",
        sequencedInterpolation: true,
        categoryXField: "name",
        tooltip: am5.Tooltip.new(root, {
        labelText: "{valueY}"
        })
    }));

    series.columns.template.setAll({ cornerRadiusTL: 5, cornerRadiusTR: 5, strokeOpacity: 0, maxWidth: 40, });

  // Change the color of all bars to grey, except the highest value
    series.columns.template.adapters.add("fill", function (fill, target) {
        return target.dataItem.dataContext.name === props.maxEntryName.split('.').slice(0, -1).join('.')
        ? am5.color(0xFFA500) // Orange for the highest value
        : am5.color(0xB0B0B0); // Grey for all others
    });
    
    series.columns.template.adapters.add("stroke", function (stroke, target) {
        return target.dataItem.dataContext.name === props.maxEntryName.split('.').slice(0, -1).join('.')
        ? am5.color(0xFFA500) // Orange for the highest value
        : am5.color(0xB0B0B0); // Grey for all others
    });

    const formattedData = props.data.map(item => ({
      ...item,
      name: item.name.split('.').slice(0, -1).join('.')
    }));
    
    xAxis.data.setAll(formattedData);
    series.data.setAll(formattedData);
    // xAxis.data.setAll(props.data);
    // series.data.setAll(props.data);

    // Make stuff animate on load
    // https://www.amcharts.com/docs/v5/concepts/animations/
    series.appear(500);
    chart.appear(500, 100);





    return () => {
        root.dispose();
    };
        });
  
  
    return (
      <>
        <div id="chartdiv" style={{width:'100%', height: '100%'}}></div>
      </>
    );
  }
  export default QaAreaChart;